export interface IProductsState {
  list: any[];
  loading: boolean;
}

export const initialUIState: IProductsState = {
  list: [],
  loading: false,
};